import { render, staticRenderFns } from "./DriverOrders.vue?vue&type=template&id=474dda3d"
import script from "./DriverOrders.vue?vue&type=script&lang=js"
export * from "./DriverOrders.vue?vue&type=script&lang=js"
import style0 from "./DriverOrders.vue?vue&type=style&index=0&id=474dda3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports